<div (scrolled)="loadNextGraphsBatch()"
     [alwaysCallback]="true"
     [infiniteScrollDistance]="2"
     [infiniteScrollThrottle]="300"
     infiniteScroll>
  <div *ngIf="noGraphs === false && !loadingPrefs" class="mlr-filters">
    <div class="mlr-filters-row">
      <div class="mlr-filter-field mlr-filter-field--routes">
        <label class="mlr-filter-label">Routes</label>
        <div class="mlr-filter-control">
          <p-multiSelect
            [(ngModel)]="selectedMarkets2Transport"
            (onChange)="onSelectGraphs()"
            [options]="market2TransportListSelect"
            [placeholder]="'Select route(s)'"
            filter="true"
            optionLabel="label"
            optionValue="value">
          </p-multiSelect>
          <button (click)="saveUserPrefs(true)" [disabled]="updateRoutesDisabled"
                  label="Update routes"
                  pButton></button>
        </div>
      </div>
      <div class="mlr-filter-field">
        <label class="mlr-filter-label">Time zone</label>
        <div class="mlr-filter-control">
          <p-dropdown (onChange)="changeTimeZone()"
                      [(ngModel)]="selectedTimeZone"
                      [options]="timeZoneList">
          </p-dropdown>
          <p-toggleButton (onChange)="saveUserPrefs()" [(ngModel)]="zoomIn" offLabel="Zoom in"
                          onLabel="Zoom out" styleClass="mlr-zoom-toggle"></p-toggleButton>
          <button (click)="refreshGraphsData()" [disabled]="refreshingGraphs"
                  class="mlr-refresh-button" pButton pTooltip="Refresh All Graphs" tooltipPosition="top" type="button">
            <i [class.fa-spin]="refreshingGraphs" class="fa fa-refresh"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="mlr-filters-row">
      <div class="mlr-filter-field mlr-filter-field--routes">
        <label class="mlr-filter-label">Save filters as</label>
        <div class="mlr-filter-control">
          <input [(ngModel)]="selectedConfigurationName"
                 class="filter-name"
                 id="selectedConfigurationName"
                 pInputText
                 placeholder="Configuration name"
                 type="text">
          <button (click)="saveFilterConfig()" [disabled]="!selectedConfigurationName"
                  label="Save filters"
                  pButton>
          </button>
        </div>
      </div>
      <div class="mlr-filter-field">
        <label class="mlr-filter-label">
          <ng-container *ngIf="savedUserConfigs.length > 0; else noSavedConfigsLabel">Load filters</ng-container>
          <ng-template #noSavedConfigsLabel>&nbsp;</ng-template>
        </label>
        <div class="mlr-filter-control">
          <p-dropdown *ngIf="savedUserConfigs.length > 0"
                      (onChange)="loadSavedFilterConfiguration()"
                      [(ngModel)]="selectedConfigurationId"
                      [filter]="true"
                      [options]="savedUserFilterConfigs"
                      placeholder="Select configuration to load">
          </p-dropdown>
          <button (click)="resetFilters()" class="p-button-outlined mlr-reset-button" label="Reset filters"
                  pButton>
          </button>
        </div>
      </div>
    </div>
    <p *ngIf="showChangedConfigMessage" class="mlr-unsaved-warning">You have unsaved changes. All changes will be lost
      if you exit this page</p>
  </div>

  <div *ngIf="noGraphs === false" class="mlr-grid" [ngClass]="{'mlr-grid--single': zoomIn === true}">
    <ng-container *ngFor="let index of markets2Transport">
      <div *ngIf="(listObservable[index]) && isDisplayedData(index) && graphData[index]" class="mlr-card">
        <div class="mlr-card-header">
          <span class="mlr-card-title"
                [pTooltip]="technicalPopService.getCageTooltip(getTechnicalPopFromLabel(index))">{{ getGraphLegend(index) }}</span>
          <div class="mlr-card-actions">
            <button (click)="refreshSingleGraph(index)" [disabled]="refreshingGraphIds[index]"
                    class="mlr-action-button" pButton
                    pTooltip="Refresh this graph" type="button">
              <i [class.fa-spin]="refreshingGraphIds[index]" class="fa fa-refresh"></i>
            </button>
            <button (click)="exportCsv(index)" *ngIf="graphData[index]['datasets'].length > 0"
                    class="mlr-action-button" icon="fa fa-download" pButton
                    pTooltip="Export CSV" type="button"></button>
            <button (click)="exportPng(index)" *ngIf="graphData[index]['datasets'].length > 0"
                    class="mlr-action-button" icon="fa fa-image" pButton
                    pTooltip="Export PNG" type="button"></button>
            <button (click)="hideGraph(index)"
                    class="mlr-action-button" icon="fa fa-eye-slash" label="Hide" pButton
                    pTooltip="Hide graph" type="button"></button>
          </div>
        </div>

        <ng-container *ngIf="graphData[index]['datasets'].length > 0">
          <div class="mlr-card-toolbar">
            <div class="mlr-toolbar-field">
              <label class="mlr-filter-label">Unit</label>
              <p-dropdown (onChange)="reloadCharts(index)"
                          [(ngModel)]="graphExecutionTimeOptions[index].scales.x.time.unit"
                          [options]="zoomOptions"
                          [style]="{'minWidth':'90px'}">
              </p-dropdown>
            </div>
            <div class="mlr-toolbar-field">
              <label class="mlr-filter-label">Period</label>
              <p-selectButton (onChange)="updateTimeScale(index)" [(ngModel)]="selectedPeriod[index]"
                              [options]="periods"></p-selectButton>
            </div>
            <div class="mlr-toolbar-field">
              <label class="mlr-filter-label">&nbsp;</label>
              <button (click)="resetCharZoom(index)" class="p-button-outlined mlr-toolbar-reset"
                      label="Reset layout" pButton type="button"></button>
            </div>
          </div>

          <p-chart #chart
                   [data]="graphData[index]"
                   [id]="index"
                   [options]="graphExecutionTimeOptions[index]"
                   [plugins]="chartPlugins"
                   class="mlr-chart"
                   type="line"></p-chart>
          <div class="mlr-zoom-hint">Drag to zoom &middot; Shift + drag to pan &middot; Ctrl + scroll to zoom</div>
        </ng-container>

        <div *ngIf="graphData[index]['datasets'].length === 0" class="mlr-empty">
          <i class="fa fa-line-chart"></i>
          <span>No data available for this route</span>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<div *ngIf="noGraphs === true">
  <h2>No Graph data to be displayed</h2>
</div>
